function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 21.296)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M340.088 0C399.145 0 447 47.809 447 106.808v97.088c0 59-47.855 106.808-106.912 106.808-59.056 0-106.912-47.809-106.912-106.808v-97.088C233.23 47.86 281.084 0 340.088 0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0F1941",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M276.772 289.9C304.276 217.292 368.59 162.76 447 148.994v-42.187C447 47.808 399.145 0 340.088 0c-59.056 0-106.912 47.809-106.912 106.808v97.088c.053 35.305 17.197 66.565 43.596 86.003zM9.729 0C6.469 0 3.208.158 0 .42V310.18c3.208.262 6.416.42 9.729.42 59.056 0 106.912-47.809 106.912-106.808v-96.983C116.588 47.86 68.733 0 9.729 0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M276.772 289.9c17.722 13.028 39.651 20.751 63.316 20.751 59.057 0 106.912-47.808 106.912-106.807v-54.849c-78.41 13.765-142.724 68.298-170.228 140.904z",
  fill: "#2175D9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.588 131.08c-4.05-3.047-9.098-4.834-14.567-4.834-13.41 0-24.296 10.876-24.296 24.273s10.886 24.272 24.296 24.272c5.47 0 10.518-1.787 14.567-4.834V131.08z",
  fill: "#6BA5B4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFB511",
  fillRule: "nonzero",
  cx: 327.73,
  cy: 72.816,
  rx: 24.296,
  ry: 24.272
}), /*#__PURE__*/React.createElement("path", {
  d: "m352.814 88.472-53.85-22.275c-2.472-1.051-3.681-3.888-2.63-6.357 1.052-2.47 3.892-3.678 6.364-2.627l53.85 22.276c2.472 1.05 3.681 3.887 2.63 6.356a4.919 4.919 0 0 1-6.364 2.627z",
  fill: "#E74536",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#F7F5F0",
  fillRule: "nonzero",
  cx: 325.521,
  cy: 160.185,
  rx: 4.838,
  ry: 4.833
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#F7F5F0",
  fillRule: "nonzero",
  cx: 92.292,
  cy: 228.168,
  rx: 4.838,
  ry: 4.833
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#F7F5F0",
  fillRule: "nonzero",
  cx: 24.296,
  cy: 82.536,
  rx: 4.838,
  ry: 4.833
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(91.258)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165.377 56.236c2.522-21.823-9.511-43.54-30.792-52.374-21.282-8.834-45.138-1.998-58.8 15.25-5.57.578-10.614 4.101-12.874 9.622-2.312 5.522-1.208 11.621 2.312 15.933a50.957 50.957 0 0 0 3.206 24.346C53.032 72.8 40.053 82.79 34.01 97.356L9.734 155.934c-1.419 3.418.578 7.52 4.466 9.15l5.36 2.208L1.537 210.78c-4.256 10.306.63 22.085 10.93 26.344 10.299 4.26 22.069-.63 26.325-10.937l6.411-15.512 10.3-24.872c.735-1.736 2.679-2.524 4.413-1.84 1.734.735 2.522 2.681 1.84 4.416l-1.262 3.103-15.449 37.281c-4.256 10.307.63 22.086 10.93 26.345 10.3 4.26 22.07-.631 26.326-10.938l18.023-43.486 5.36 2.208c3.888 1.63 8.197.158 9.616-3.312l24.434-58.894c5.99-14.513 3.889-30.551-4.361-44.013 7.461-3.26 14.187-8.308 19.39-14.88 5.57-.58 10.614-4.102 12.873-9.624 2.312-5.52 1.209-11.568-2.26-15.932z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.377 56.236c2.522-21.823-9.511-43.54-30.792-52.374-21.282-8.834-45.138-1.998-58.8 15.25-5.57.578-10.614 4.101-12.874 9.622-2.312 5.522-1.208 11.621 2.312 15.933a50.957 50.957 0 0 0 3.206 24.346C53.032 72.8 40.053 82.79 34.01 97.356L9.734 155.934c-1.419 3.418.578 7.52 4.466 9.15l5.36 2.208L1.537 210.78c-4.256 10.306.63 22.085 10.93 26.344 10.299 4.26 22.069-.63 26.325-10.937l6.411-15.512 10.3-24.872c.735-1.736 2.679-2.524 4.413-1.84 1.734.735 2.522 2.681 1.84 4.416l-1.262 3.103-15.449 37.281c-4.256 10.307.63 22.086 10.93 26.345 10.3 4.26 22.07-.631 26.326-10.938l18.023-43.486 5.36 2.208c3.888 1.63 8.197.158 9.616-3.312l24.434-58.894c5.99-14.513 3.889-30.551-4.361-44.013 7.461-3.26 14.187-8.308 19.39-14.88 5.57-.58 10.614-4.102 12.873-9.624 2.312-5.52 1.209-11.568-2.26-15.932z",
  fillOpacity: 0.7,
  fill: "#C7D1DC"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#0F1941",
  fillRule: "nonzero",
  cx: 115.248,
  cy: 50.451,
  rx: 40.986,
  ry: 41.015
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.737 29.05c-3.468-1.42-7.198-1.21-10.299.315.316.105.63.21.946.368 8.565 3.576 12.664 13.41 9.09 21.98a7.452 7.452 0 0 1-.42.947c3.258-1.157 6.096-3.628 7.514-7.099a12.61 12.61 0 0 0-6.83-16.511z",
  fill: "#F7F5F0",
  fillRule: "nonzero"
})));
function SvgAstronaut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 332,
    viewBox: "0 0 447 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.d62e944e.svg";
export { ForwardRef as ReactComponent };